<template>
  <v-main class="pt-12">
    <v-sheet class="mt-3 pa-4 primary lighten-1">
      <v-row>
        <v-col class="col-md-4 col-lg-2" cols="6">
          <v-dialog
              :return-value.sync="reportDate"
              persistent
              ref="dialog"
              v-model="modal"
              width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                  dark
                  label="Report Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-model="reportDate"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="reportDate">
              <v-spacer></v-spacer>
              <v-btn @click="modal = false" text>Cancel</v-btn>
              <v-btn @click="$refs.dialog.save(reportDate)" text>OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
    </v-sheet>
    <v-card class="mt-6 mb-4">
      <v-list-item
          dark
          class="primary"
      >
        <v-list-item-avatar>
          <v-icon>
            mdi-chart-arc
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">Applications by Agents</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4" class="pb-0" v-for="(group, index) in metrics.agents" :key="index">
            <applications-card :title="group.title" :metrics="group.metrics"></applications-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mt-6 mb-4">
      <v-list-item
          dark
          class="primary"
      >
        <v-list-item-avatar>
          <v-icon>
            mdi-chart-arc
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">Applications by Managers</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4" class="pb-0" v-for="(manager, index) in metrics.managers" :key="index">
            <applications-card :title="manager.title" :metrics="manager.metrics"></applications-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mt-6 mb-4">
      <v-list-item
          dark
          class="primary"
      >
        <v-list-item-avatar>
          <v-icon>
            mdi-chat
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">Messages by Managers</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4" class="pb-0" v-for="(manager, index) in metrics.managers" :key="index">
            <messages-card :title="manager.title" :metrics="manager.metrics"></messages-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-main>
</template>

<script>
import {mapGetters} from 'vuex'
// import moment from 'moment'
import ApplicationsCard from './Widgets/ApplicationsCard'
import MessagesCard from './Widgets/MessagesCard'
import {errorNotification} from "@/components/utils";


export default {
  components: {ApplicationsCard, MessagesCard},
  name: 'Reports',
  data() {
    return {
      modal: false,
      reportDate: new Date().toISOString().substr(0, 10),
      metrics: {}
    }
  },
  watch: {
    reportDate() {
      this.fetchData()
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isAdmin'
    ])
  },
  methods: {
    fetchData() {
      this.$axios.get(`/reports/?date=${this.reportDate}`, {})
          .then((response) => {
            this.metrics = response.data
          })
          .catch((error) => {
            errorNotification(error)
          })
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>